import React, { Fragment, useEffect, useState } from "react";
import ReactDatatable from "@ashvin27/react-datatable";
import { postMethod } from "../../../../_services/_postMethod";
import Loader from "../../../modules/loader";
import { API_BASE_URL } from "../../../../_services/constant";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";


const CustomerRetailerSales = (props) => {
  const [grid, setGrid] = React.useState([]);
  const [load, setLoad] = React.useState(false);
  const editRecord2 = (val) => {
    var temp = window.btoa(val);
    props.history.push("/branch/preview-retailer-sale/add?id=" + temp);
  };

  const [gridParam, setGridParam] = useState({});

  // ------------------------------
  const viewPdf = (fileName) => {
    if (!fileName) return;

    const pdfUrl = `${API_BASE_URL}bills/${fileName}`;
    window.open(pdfUrl, "_blank", "noopener,noreferrer");
  };


  const viewHtml = async (htmlContent) => {
    if (!htmlContent) return;

    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlContent;
    tempDiv.style.position = "fixed";
    tempDiv.style.left = "-99999px";
    tempDiv.style.top = "0";
    tempDiv.style.width = "794px";
    tempDiv.style.background = "#fff";
    document.body.appendChild(tempDiv);

    try {
      const canvas = await html2canvas(tempDiv, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#fff",
        width: tempDiv.scrollWidth,
        height: tempDiv.scrollHeight,
        windowWidth: tempDiv.scrollWidth,
        windowHeight: tempDiv.scrollHeight,
      });

      const imgData = canvas.toDataURL("image/jpeg", 0.6);
      const pdf = new jsPDF({
        orientation: "p",
        unit: "mm",
        format: "a4",
        compress: true,
      });

      const imgWidth = 190;
      const marginX = 10;
      const marginY = 10;
      const footerHeight = 28;  // larger gap above footer text
      const pageContentHeight = 297 - marginY - footerHeight; // ~259mm usable per page
      const pxPerMm = canvas.width / imgWidth;

      // Get pixel data once for smart-break scanning
      const srcCtx = canvas.getContext("2d");
      const imageData = srcCtx.getImageData(0, 0, canvas.width, canvas.height);

      // Find nearest white/empty row above a theoretical cut point
      const findSafeCutPx = (theoreticalPx) => {
        const searchRange = Math.round(35 * pxPerMm); // scan up to 35mm upward
        for (let y = theoreticalPx; y > Math.max(0, theoreticalPx - searchRange); y--) {
          let isLight = true;
          const step = Math.max(1, Math.round(canvas.width / 80)); // sample 80 pixels per row
          for (let x = 0; x < canvas.width; x += step) {
            const idx = (y * canvas.width + x) * 4;
            const r = imageData.data[idx];
            const g = imageData.data[idx + 1];
            const b = imageData.data[idx + 2];
            if (r < 250 || g < 250 || b < 250) { isLight = false; break; }
          }
          if (isLight) return y;
        }
        return theoreticalPx; // fallback: use original cut
      };

      const totalImgHeightMm = (canvas.height * imgWidth) / canvas.width;
      let sliceStartPx = 0;
      let isFirstPage = true;

      while (sliceStartPx < canvas.height) {
        // Theoretical end of this page's content in pixels
        const theoreticalEndPx = sliceStartPx + Math.round(pageContentHeight * pxPerMm);
        const isLastSlice = theoreticalEndPx >= canvas.height;

        // For non-last pages, find a safe (white row) cut point
        const safeCutPx = isLastSlice
          ? canvas.height
          : findSafeCutPx(Math.min(theoreticalEndPx, canvas.height));

        const sHeight = safeCutPx - sliceStartPx;
        if (sHeight <= 0) break;

        const sliceHeightMm = (sHeight * imgWidth) / canvas.width;

        // Draw slice
        const sliceCanvas = document.createElement("canvas");
        sliceCanvas.width = canvas.width;
        sliceCanvas.height = sHeight;
        const ctx = sliceCanvas.getContext("2d");
        ctx.drawImage(canvas, 0, sliceStartPx, canvas.width, sHeight, 0, 0, canvas.width, sHeight);
        const sliceData = sliceCanvas.toDataURL("image/jpeg", 0.7);

        if (!isFirstPage) pdf.addPage();

        pdf.addImage(sliceData, "JPEG", marginX, marginY, imgWidth, sliceHeightMm, undefined, "FAST");

        // Footer
        pdf.setFontSize(8.5);
        pdf.setTextColor(120, 120, 120);
        pdf.text(
          "Thank you for shopping with us! We appreciate your business.",
          105,
          288,
          { align: "center" }
        );

        sliceStartPx = safeCutPx;
        isFirstPage = false;
      }

      const pdfBlob = pdf.output("blob");
      const blobUrl = URL.createObjectURL(pdfBlob);
      window.open(blobUrl, "_blank");
    } catch (error) {
      console.error("Error generating PDF:", error);
    } finally {
      if (tempDiv.parentNode) {
        tempDiv.parentNode.removeChild(tempDiv);
      }
    }
  };


  // ------------------------------

  const columns = [
    {
      key: "entry_no",
      text: "Entry No.",
      align: "left",
      sortable: true,
    },
    {
      key: "title",
      text: "Title",
      align: "left",
      sortable: true,
    },
    {
      key: "customer_name",
      text: "Customer Name",
      align: "left",
      sortable: true,
    },
    {
      key: "mobile",
      text: "Mobile",
      align: "left",
      sortable: true,
    },
    {
      key: "no_of_product",
      text: "Products",
      align: "left",
      sortable: false,
      cell: (record) => {
        return (
          <Fragment>
            {record.no_of_product}({record.sales_qty})
          </Fragment>
        );
      },
    },
    {
      key: "remarks",
      text: "Remarks",
      align: "left",
      sortable: true,
    },
    {
      key: "date",
      text: "Date",
      align: "left",
      sortable: true,
    },
    //    {
    //   key: "action",
    //   text: "Action",
    //   className: "action",
    //   width: 100,
    //   align: "left",
    //   sortable: false,
    //   cell: (record) => {
    //     return (
    //       <Fragment>
    //         {record.bill_pdf && (
    //           <button
    //             className="btn btn-link btn-sm"
    //             title="View Bill"
    //             onClick={() => viewPdf(record.bill_pdf)}
    //           >
    //             <i className="fa fa-eye"></i>
    //           </button>
    //         )}
    //       </Fragment>
    //     );
    //   },
    // }

    {
      key: "action",
      text: "Action",
      className: "action",
      width: 100,
      align: "left",
      sortable: false,
      cell: (record) => {
        return (
          <Fragment>
            {/* {record.bill_pdf && (
              <button
                className="btn btn-link btn-sm"
                title="View Bill PDF"
                onClick={() => viewPdf(record.bill_pdf)}
              >
                <i className="fa fa-eye"></i>
              </button>
            )} */}

            {record.invoice_html && (
              <button
                className="btn btn-link btn-sm"
                title="View Invoice HTML"
                onClick={() => viewHtml(record.invoice_html)}
              >
                <i className="fa fa-eye"></i>
              </button>
            )}
          </Fragment>
        );
      },
    }

  ];

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50],
  };

  useEffect(() => {
    setLoad(true);
    postMethod("api/transactions/stockReatilerSales/browse", gridParam).then((data) => {
      // alert(JSON.stringify(data.data.))
      setGrid(data.data);
      setLoad(false);
    });
  }, []);

  return (
    <>
      {load ? <Loader /> : null}
      <div className="card card-custom gutter-b">
        <div className="card-header">
          <div className="card-title">
            <h3 className="card-label">Customer Sales</h3>
          </div>
          <div className="card-toolbar d-flex justify-content-end gap-2" style={{ gap: "8px" }}>
            <a
              href="/branch/stock-retailer-sale/add"
              className="btn btn-sm btn-outline-theme font-weight-bold py-2 px-3"
            >
              <i className="flaticon2-user"></i> Add Retailer Sales
            </a>
          </div>

        </div>
        <div className="card-body">
          <ReactDatatable config={config} records={grid} columns={columns} />
        </div>


      </div>
    </>
  );
};

export default CustomerRetailerSales;
